
import TMap from 'tmaps';
export default {
  data() {
    return {
      // 新增
      center: null,
      tMapSearch: null,
      searchValue: "", // 搜索值
      listLoading: false, // 列表加载状态
    };
  },
  methods: {
    // 腾讯地图
    tmapInit() {
      let center = new TMap.LatLng(this.lat, this.lng);
      let map = new TMap.Map(document.getElementById("map"), {
        center: center, //设置地图中心点坐标
        zoom: 15, //设置地图缩放级别
        // pitch: 43.5,  //设置俯仰角
        // rotation: 45    //设置地图旋转角度
      });

      this.map = map;
      this.center = center;

      this.tMapSearch = new TMap.service.Search({ pageSize: 20 }); // 每页条目数，最大限制为20条，默认为10条
      console.log("search");
      map.on("click", this.tmapClick);

      this.addTMarker();
    },
    tmapClick(e) {
      console.log("点击后：", e);

      let { lat, lng } = e.latLng;
      this.position = [lat, lng];
      this.center = new TMap.LatLng(...this.position);
      this.addTMarker();
    },
    // isGetList -是否获取地图列表，默认获取
    addTMarker(isGetList = true) {
      if (this.marker) {
        this.marker.remove(["marker"]);
      }

      this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: {
          // 点标记样式
          marker: new TMap.MarkerStyle({
            width: 20, // 样式宽
            height: 30, // 样式高
            anchor: { x: 10, y: 30 }, // 描点位置
          }),
        },
        geometries: [
          // 点标记数据数组
          {
            // 标记位置(纬度，经度，高度)
            position: this.center,
            id: "marker",
          },
        ],
      });
      console.log("this.marker", this.marker);

      if (isGetList) {
        this.getTMapAddressList();
      }
    },
    getTMapAddressList() {
      const key = this.searchValue.trim();
      if (this.listLoading) {
        return;
      }
      this.listLoading = true;
      this.addressList = [];
      this.tMapSearch[key ? "searchNearby" : "explore"]({
        keyword: key, // 搜索关键字
        center: this.center,
        radius: 15, // 搜索半径，取值范围：10到1000
        autoExtend: true, // 当前范围无结果时，是否自动扩大范围
        filter:
          "category=汽车服务,汽车销售,汽车维修,摩托车服务,餐饮服务,购物服务,生活服务,体育休闲服务,医疗保健服务,住宿服务,风景名胜,商务住宅,政府机构及社会团体,科教文化服务,金融保险服务,公司企业,公共设施",
        // orderby: '_distance', // 排序，支持按距离由近到远排序
        pageIndex: 1,
      })
        .then((res) => {
          console.log(
            "获取到的地址列表：",
            res,
            key ? "searchNearby" : "explore",
          );
          const data = res.data;

          // 当为搜索时，重置标点位置，当前取第一个地址的定位
          if (key && data.length > 0) {
            const location = data[0].location;

            this.center = new TMap.LatLng(location.lat, location.lng);
            this.map.setCenter(this.center);
            this.addTMarker(false); // 这里为了防止死循环必须不再刷新列表
          }

          this.addressList = data;
        })
        .catch((err) => {
          console.log("catch err", err);
        })
        .finally(() => {          
          this.listLoading = false;
        });
    },
  },
};
